import { render } from "./RiLnbDashboard.vue?vue&type=template&id=b6b0b0be"
import script from "./RiLnbDashboard.vue?vue&type=script&lang=js"
export * from "./RiLnbDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiLnbDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6b0b0be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6b0b0be', __exports__)) {
    api.reload('b6b0b0be', __exports__)
  }
  
  module.hot.accept("./RiLnbDashboard.vue?vue&type=template&id=b6b0b0be", () => {
    api.rerender('b6b0b0be', render)
  })

}


export default __exports__